<template>
  <section>
    <div class="comprobante" id="comprobante" v-if="datosNegocio">
      <p>
        <b>{{ titulo }} {{ ultimoId }}</b>
      </p>
      <p>{{ datosNegocio.nombre }}</p>
      <p>Teléfono: {{ datosNegocio.telefono }}</p>
      <p style="font-size: 9pt; margin-bottom: 1pt">
        <b>Nit:{{ datosNegocio.nit }}</b>
      </p>
      <p>Dirección: {{ datosNegocio.direccion }}</p>
      <img
        :src="datosNegocio.logo"
        alt="Aqui el logo"
        width="150"
        v-if="datosNegocio.logofactura == 1"
      />
      <p><b>Cliente:</b>{{ venta.nombreCliente }}</p>
      <p v-if="venta.nit"><b>Nit:</b> {{ venta.nit }}</p>
      <p v-if="venta.telefono"><b>Teléfono C:</b> {{ venta.telefono }}</p>
      <p v-if="venta.direccion"><b>Dirección:</b> {{ venta.direccion }}</p>
      <p><b>Atiende:</b>{{ venta.nombreUsuario }}</p>
      <p><b>Fecha: </b>{{ venta.fecha }}</p>

      <table>
        <thead>
          <th>Producto</th>
          <th></th>
          <th>Total</th>
        </thead>
        <tbody>
          <tr v-for="(producto, index) in venta.productos" :key="index">
            <td>{{ producto.nombre }}</td>
            <td>
              {{ parseInt(producto.precio).toLocaleString("es-CO") }}
              x{{ producto.cantidad }}
            </td>
            <td>
              {{
                (producto.precio * producto.cantidad).toLocaleString("es-CO", {
                  style: "currency",
                  currency: "COP",
                  minimumFractionDigits: 0,
                })
              }}
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        <b>Total:</b>
        {{ "$" + parseInt(venta.total).toLocaleString("es-CO") }}
      </p>
      <p>--------------------------</p>
      <p>MEDIO DE PAGO</p>
      <p v-if="tipo !== 'cotiza' && venta.efectivo > 0">
        <b>Efectivo:</b>
        {{ "$" + parseInt(venta.efectivo).toLocaleString("es-CO") }}
      </p>
      <p v-if="tipo !== 'cotiza' && venta.nequi > 0">
        <b>Nequi :</b>
        {{ "$" + parseInt(venta.nequi).toLocaleString("es-CO") }}
      </p>
      <p v-if="tipo !== 'cotiza' && venta.transferencia > 0">
        <b>Transferencia:</b>
        {{ "$" + parseInt(venta.transferencia).toLocaleString("es-CO") }}
      </p>
      <p v-if="tipo !== 'cotiza' && venta.tarjeta > 0">
        <b>Tarjeta:</b>
        {{ "$" + parseInt(venta.tarjeta).toLocaleString("es-CO") }}
      </p>

      <p>--------------------------</p>
      <p v-if="tipo === 'venta'">
        <b>Cambio:</b>
        {{ "$" + parseInt(venta.pagado - venta.total).toLocaleString("es-CO") }}
      </p>
      <strong
        v-if="cufe && cufe !== ''"
        style="
          word-wrap: break-word;
          white-space: normal;
          display: block;
          max-width: 100%;
        "
      >
        Cufe: {{ cufe }}
      </strong>

      <div v-if="cufe" class="qr-container">
        <p>Escanea el código QR:</p>
        <vue-qr :text="qrUrl" :size="200" :margin="5" :dotScale="0.8" />
      </div>

      <p v-if="tipo === 'cuenta' || tipo === 'apartado'">
        <b>Por pagar:</b>
        {{
          venta.porPagar.toLocaleString("es-CO", {
            style: "currency",
            currency: "COP",
            minimumFractionDigits: 0,
          })
        }}
      </p>

      <p>{{ datosNegocio.frase }}</p>
      <p>--------------------------</p>
      <p>Software MegaPos 3243717299</p>
    </div>
  </section>
</template>
<script>
import AyudanteSesion from "../../Servicios/AyudanteSesion";
import Utiles from "../../Servicios/Utiles";
import Printd from "printd";
import VueQr from "vue-qr";

export default {
  name: "ComprobanteCompra",
  components: { VueQr }, // 🔹 Aquí estaba el error antes
  props: ["venta", "tipo", "ultimoId", "cufe"],

  data: () => ({
    titulo: "",
    datosNegocio: null,
    cssText: `
                .comprobante{
                    width: 190px;
                    font-family: monospace;
                    font-size: 13px;
                }

                .comprobante > p{
                    margin: 0!important;
                    padding: 0!important;
                    text-align: center;
                }

                .comprobante > img{
                    display: block;
                    margin: 0 auto;
                }

                .comprobante > th, td {
                  border-bottom: 1px solid black;
                  font-size: 13px !important;
                  margin: 0 2px 0 0!important;
                  padding: 0!important;
                }
            `,
  }),

  beforeMount() {
    this.generarTitulo();
    this.obtenerDatosNegocio();
  },

  mounted() {
    console.log(this.venta);
    this.d = new Printd();
    const { contentWindow } = this.d.getIFrame();
    contentWindow.addEventListener("beforeprint", () =>
      console.log("before print event!")
    );
    contentWindow.addEventListener("afterprint", () =>
      console.log("after print event!")
    );
    setTimeout(() => this.imprimir(), 800);
    // 🔹 Esperar 2 segundos antes de imprimir para que el QR tenga tiempo de generarse
  },

  methods: {
    generarTitulo() {
      switch (this.tipo) {
        case "venta":
          this.titulo = "COMPROBANTE DE COMPRA";
          break;
        case "cuenta":
          this.titulo = "COMPROBANTE DE CUENTA";
          break;

        case "apartado":
          this.titulo = "COMPROBANTE DE APARTADO";
          break;

        case "cotiza":
          this.titulo = "COTIZACIÓN";
          break;

        default:
          this.titulo = "COMPROBANTE";
      }
    },

    obtenerDatosNegocio() {
      this.datosNegocio = AyudanteSesion.obtenerDatosNegocio();
      this.datosNegocio.logo = Utiles.regresarRuta() + this.datosNegocio.logo;
    },

    imprimir() {
      let zona = document.getElementById("comprobante");
      setTimeout(() => this.d.print(zona, [this.cssText]), 10);
      this.$emit("impreso", false);
    },
  },
  computed: {
    qrUrl() {
      return `https://catalogo-vpfe.dian.gov.co/document/searchqr?documentkey=${this.cufe}`;
    },
  },
};
</script>
<style scoped>
.comprobante {
  width: 250px;
  font-family: monospace;
  font-size: 14px;
}

.comprobante > p {
  margin: 0 !important;
  padding: 0 !important;
  text-align: center;
}
#qrcode-container {
  margin-top: 20px;
  text-align: center;
}

#qrcode-canvas {
  margin: 10px auto;
  display: block;
}
.comprobante > img {
  display: block;
  margin: 0 auto;
}

.comprobante > th,
td {
  border-bottom: 1px solid #ddd;
  font-size: 12px !important;
  margin: 0 !important;
  padding: 0 !important;
}

.qr-container {
  text-align: center;
  margin-top: 10px;
}
.filled {
  background-color: black;
}
</style>
